<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" [opened]="drawerPinned" [mode]="drawerMode" [fixedInViewport]="mobileQuery.matches" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'">
    <mat-nav-list>
      <div class="clearfix">
        @if (!device.mobile) {
          <button mat-icon-button (click)="pinDrawer()" class="float-left ms-2" [ngClass]="drawerPinned === false ? 'unpinned' : ''">
            <mat-icon class="pindrawer">push_pin</mat-icon>
          </button>
        }
        <button mat-icon-button (click)="closeDrawer()" class="float-right me-2">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div [hidden]="!_login.loggedIn()">
        @if (_login.user()) {
          <div mat-list-item class="text-center input-full-width">
            <div>
              <label for="uploadAvatarInput">
                <img height="150" width="150" [src]="_login.user()?.avatarUrl" class="avatarIcon img-thumbnail" />
              </label>
              <input type="file" (change)="uploadAvatar($event)" style="display: none" id="uploadAvatarInput" accept="image/png,image/x-png,image/jpeg" />
            </div>
          </div>
        }

        <div style="margin-top: 30px">
          <a mat-list-item routerLink="/home" routerLinkActive="active" (click)="checkDrawer()">
            <mat-icon>home</mat-icon>
            <span class="nav-caption">Startseite</span>
          </a>
          @if (_login.hasPermission('user-list')) {
            <a mat-list-item routerLink="user" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>contacts</mat-icon>
              <span class="nav-caption">Kontakte</span>
            </a>
          }
          @if (_login.hasPermission('responder') || _login.hasPermission('evd-view') || _login.hasPermission('event-watcher')) {
            <a mat-list-item [matMenuTriggerFor]="shifts">
              <mat-icon>calendar_view_month</mat-icon>
              <span class="nav-caption">Dienstpläne</span>
            </a>
          }
          <mat-menu #shifts="matMenu" overlapTrigger="false">
            <div class="fullWidthSidebar"></div>
            @if (_login.hasPermission('responder')) {
              <button mat-menu-item routerLink="responder" routerLinkActive="active" (click)="checkDrawer()">
                <mat-icon>schedule</mat-icon>
                <span class="nav-caption">First Responder</span>
              </button>
            }
            @if (_login.hasPermission('evd-view')) {
              <button mat-menu-item routerLink="evd" routerLinkActive="active" (click)="checkDrawer()">
                <mat-icon>event_note</mat-icon>
                <span class="nav-caption">Einsatzleiter vom Dienst </span>
              </button>
            }
            @if (_login.hasPermission('event-watcher')) {
              <button mat-menu-item routerLink="guards" routerLinkActive="active" (click)="checkDrawer()">
                <mat-icon>security</mat-icon>
                <span class="nav-caption">Sicherheitswachen</span>
              </button>
            }
          </mat-menu>
          @if (_login.hasPermission('event')) {
            <a mat-list-item routerLink="event/list" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>calendar_today</mat-icon>
              <span class="nav-caption">Termine</span>
            </a>
          }
          @if (_login.hasPermission('alarm-view') && this._login.hasPermission('alarm-view-non-whitelisted')) {
            <a mat-list-item routerLink="alarms" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>fireplace</mat-icon>
              <span class="nav-caption">Einsatz</span>
            </a>
          }
          @if (_login.hasPermission('time')) {
            <a mat-list-item routerLink="timetracking" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>more_time</mat-icon>
              <span class="nav-caption">Zeiterfassung</span>
            </a>
          }
          @if (_login.hasPermission('material-manage')) {
            <a mat-list-item routerLink="material" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>construction</mat-icon>
              <span class="nav-caption">Materialverwaltung</span>
            </a>
          }
          <a mat-list-item routerLink="statistics" routerLinkActive="active" (click)="checkDrawer()">
            <mat-icon>analytics</mat-icon>
            <span class="nav-caption">Auswertungen</span>
          </a>
        </div>
        @if (_login.hasPermission('admin-user-drivingperm-edit') || _login.hasPermission('admin-user-atemschutz-edit') || _login.hasPermission('social-media') || _login.hasPermission('admin-guards')) {
          <a mat-list-item [matMenuTriggerFor]="fields">
            <mat-icon>folder</mat-icon>
            <span class="nav-caption">Fachbereiche</span>
          </a>
        }
        <mat-menu #fields="matMenu" overlapTrigger="false">
          <div class="fullWidthSidebar"></div>
          @if (_login.hasPermission('admin-user-drivingperm-edit')) {
            <button mat-menu-item routerLink="admin/fields/maschinisten" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>drive_eta</mat-icon>
              <span class="nav-caption">Maschinisten</span>
            </button>
          }
          @if (_login.hasPermission('admin-user-atemschutz-edit')) {
            <button mat-menu-item routerLink="admin/fields/atemschutz" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>fire_extinguisher</mat-icon>
              <span class="nav-caption">Atemschutz</span>
            </button>
          }
          @if (_login.hasPermission('admin-secretary')) {
            <button mat-menu-item routerLink="admin/fields/secretary" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>edit_note</mat-icon>
              <span class="nav-caption">Schriftführer</span>
            </button>
          }
          @if (_login.hasPermission('social-media')) {
            <button mat-menu-item routerLink="admin/fields/social-media" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>monochrome_photos</mat-icon>
              <span class="nav-caption">Social Media</span>
            </button>
          }
          @if (_login.hasPermission('admin-guards')) {
            <button mat-menu-item routerLink="admin/fields/guards" routerLinkActive="active" (click)="checkDrawer()">
              <mat-icon>security</mat-icon>
              <span class="nav-caption">Sicherheitswachen</span>
            </button>
          }
        </mat-menu>
        @if (_login.hasPermission('admin-groups-list')) {
          <a mat-list-item routerLink="admin/groups" routerLinkActive="active" (click)="checkDrawer()">
            <mat-icon>groups</mat-icon>
            <span class="nav-caption">Gruppenverwaltung</span>
          </a>
        }
        @if (_login.hasPermission('admin-settings')) {
          <a mat-list-item routerLink="admin/settings" routerLinkActive="active" (click)="checkDrawer()">
            <mat-icon>settings</mat-icon>
            <span class="nav-caption">Einstellungen</span>
          </a>
        }
        @if (_com.isRunningInApp()) {
          <a mat-list-item (click)="this._com.sendAction('options'); checkDrawer()">
            <mat-icon>open_in_new</mat-icon>
            <span class="nav-caption">App Einstellungen</span>
          </a>
        }
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      @if (!drawerPinned) {
        <button type="button" aria-label="Toggle sidenav" [hidden]="!_login.loggedIn()" mat-icon-button (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
      }
      @if (!_login.loggedIn()) {
        <div class="centerToNav">
          <img [src]="logoUrl" height="40" width="40" />
          @if (!device.mobile) {
            <span class="nostyle d-none d-md-inline d-lg-inline d-xl-inline" style="margin-left: 20px">{{ title }}</span>
          }
        </div>
      }

      <div class="centerToNav" routerLink="home" style="cursor: pointer" [hidden]="scrolled() || !_login.loggedIn()">
        @if (!device.mobile) {
          <img [src]="logoUrl" height="40" width="40" />
        }
        <a style="margin-left: 20px; color: #fff">{{ title }}</a>
      </div>

      <div class="centerToNav" (click)="scrollTop()" style="cursor: pointer" [hidden]="!scrolled() || !_login.loggedIn()">
        @if (!device.mobile) {
          <img [src]="logoUrl" height="40" width="40" class="nostyle d-none d-md-inline d-lg-inline d-xl-inline" />
        }
        <a style="margin-left: 20px; color: #fff">{{ production ? _pageTitle.heading() : title }}</a>
      </div>

      <div [hidden]="!_login.loggedIn()" class="float-right toolbar-actions">
        <app-live-status />
        <app-notification-nav #notificationNav></app-notification-nav>
        <button type="button" aria-label="Benutzermenü" mat-icon-button [matMenuTriggerFor]="userProfileDropdown">
          <mat-icon aria-hidden="true">person</mat-icon>
        </button>
        <mat-menu #userProfileDropdown="matMenu" style="width: 100%" overlapTrigger="false">
          <div class="smallWidthProfile"></div>
          @if (pwaS.promptEvent) {
            <button mat-menu-item (click)="installPwa()">
              <mat-icon>install_desktop</mat-icon>
              <span>Zum Startbildschirm</span>
            </button>
          }
          <button mat-menu-item routerLink="/profile/">
            <mat-icon>assignment_ind</mat-icon>
            <span>Mein Profil</span>
          </button>
          @if (_login.hasPermission('profile-alarms')) {
            <button mat-menu-item routerLink="/profile/alarms">
              <mat-icon>inbox</mat-icon>
              <span>Einsatzbestätigungen</span>
            </button>
          }
          <button mat-menu-item routerLink="/profile/timeline">
            <mat-icon>view_timeline</mat-icon>
            <span>Meine Laufbahn</span>
          </button>
          <button mat-menu-item routerLink="/settings">
            <mat-icon>settings</mat-icon>
            <span>Einstellungen</span>
          </button>
          <button mat-menu-item>
            <a href="https://sso.feuerwehr-ottobrunn.de/realms/master/account/account-security/signing-in" target="_blank" style="color: unset">
              <mat-icon>vpn_key</mat-icon>
              <span>Passwort ändern</span></a
            >
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>power_settings_new</mat-icon>
            <span>Ausloggen</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <router-outlet></router-outlet>
    <!-- Add Content Here -->
  </mat-sidenav-content>
</mat-sidenav-container>
<div class="helpButtonOverlay" [hidden]="!_login.loggedIn()">
  <button mat-mini-fab class="float-right" color="primary" (click)="openHelp()">
    <mat-icon>help</mat-icon>
  </button>
</div>
